module.exports = __webpack_public_path__ + "static/img_5-ab5dc924df6b2d7683c296cfe316407e.png";